import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { googleAnalyticPromotionImpressions, googleAnalyticPromotionClicks } from 'actions/googleAnalytic'
import { PROMO_CALL } from 'constant'
import withType from 'components/common/hoc/withType'
import BOTFeaturedDeals from './BOTFeaturedDeals'

const withSendAnalyticOnDidMount = lifecycle({
  componentDidMount() {
    const { items, googleAnalyticPromotionImpressions } = this.props

    googleAnalyticPromotionImpressions({ items, creative: 'service-page-offers' })
  }
})

const withPromotionClickHandler = withHandlers({
  handlePromotionClick: ({ googleAnalyticPromotionClicks }) => ({ event, item, index }) => {
    if (event.target.getAttribute('data-type') === PROMO_CALL) {
      googleAnalyticPromotionClicks({ item, index, creative: 'service-page-offers' })
    }
  }
})

export default compose(
  withType({ type: 'BOTFeaturedDeals' }),
  connect(null, { googleAnalyticPromotionImpressions, googleAnalyticPromotionClicks }),
  withSendAnalyticOnDidMount,
  withPromotionClickHandler
)(BOTFeaturedDeals)
